import Image from 'next/image';

const DataWebCrayon = () => {
  const _link = 'http://qr.afip.gob.ar/?qr=7fvzNMzJvOfE3U-aiAYTVA,,';
  const imgSrc = '/DATAWEB-CRAYON.jpg';
  return (
    <div className="data-web-afip">
      <a href={_link} target="_blank" rel="noopener noreferrer">
        <Image src={imgSrc} alt="QR Code" width={80} height={150} />
      </a>
    </div>
  );
};

export default DataWebCrayon;
